export const COLOR_PALETTE = [
    ['#00FFAA', '#54FFC6', '#A8FFE2', '#008055', '#00AB72'],
    ['#FF0000', '#FF5454', '#FFA8A8', '#570000', '#AB0000'],
    ['#0000FF', '#5454FF', '#A8A8FF', '#000080', '#0000AB'],
    ['#AAFF00', '#C6FF54', '#E2FFA8', '#558000', '#72AB00',],
    ['#54C6FF', '#A8E2FF', '#005580', '#0072AB', '#00AAFF'],
    ['#FFAA00', '#FFC654', '#FFE2A8', '#805500', '#AB7200'],
    ['#AA00FF', '#C654FF', '#E2A8FF', '#550080', '#7200AB'],
    ['#FF00AA', '#FF54C6', '#FFA8E2', '#800055', '#AB0072'],
    ['#00FF00', '#54FF54', '#A8FFA8', '#008000', '#00AB00'],
    ['#FFE15D', '#F49D1A', '#808080', '#DC3535', '#461959']
  ];